import React from 'react'

import PropTypes from 'prop-types'

import './message.css'

const Message = (props) => {
  return (
    <main className="message-message">
      <main className="message-main">
        <h1 className="message-heading">{props.Heading}</h1>
        <div className="message-input-field">
          <input
            type="email"
            placeholder={props.textinput_placeholder}
            className="message-textinput input"
          />
        </div>
        <div className="message-input-field1">
          <input
            type="email"
            placeholder={props.Input_placeholder}
            className="message-input input"
          />
        </div>
      </main>
      <div className="message-buy button">
        <span className="message-text">{props.Text}</span>
      </div>
      <h1 className="message-notice">{props.Notice}</h1>
    </main>
  )
}

Message.defaultProps = {
  Notice: 'Due to heavy work reponse might be delayed ',
  Heading: 'Any query?',
  Text: 'Send',
  textinput_placeholder: 'Enter your email',
  Input_placeholder: 'Query?',
}

Message.propTypes = {
  Notice: PropTypes.string,
  Heading: PropTypes.string,
  Text: PropTypes.string,
  textinput_placeholder: PropTypes.string,
  Input_placeholder: PropTypes.string,
}

export default Message
